(() => {
  if (customElements.get('klever-load-more')) return;
  class KleverLoadMore extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.list = this.parentElement.querySelector('#KleverProductList');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.list || !this.button || !this.status) return;
      this.ready = true;
      this.querySelector('[data-pagination-fallback]').hidden = true;
      this.querySelector('.kb-load-more__controls').hidden = false;
      this.updateStatus();
      this.button.addEventListener('click', () => this.load());
    }
    disconnectedCallback() { this.controller?.abort(); }
    updateStatus() {
      const count = this.list.querySelectorAll('[data-ks-product]').length;
      this.status.textContent = `${count} productos cargados de ${this.dataset.total}`;
    }
    async load() {
      if (this.busy || !this.dataset.nextUrl) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Cargando…';
      this.list.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.dataset.nextUrl, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid pagination URL');
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Pagination request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextList = page.querySelector('#KleverProductList');
        const pagination = page.querySelector('klever-load-more');
        if (!nextList || !pagination) throw new Error('Missing catalog');
        const ids = new Set([...this.list.querySelectorAll('[data-product-id]')].map(item => item.dataset.productId));
        const items = [...nextList.querySelectorAll('[data-ks-product]')].filter(item => !ids.has(item.dataset.productId));
        if (!items.length) throw new Error('Empty or repeated page');
        const fragment = document.createDocumentFragment();
        items.forEach(item => fragment.append(document.importNode(item, true)));
        this.list.append(fragment);
        this.dataset.nextUrl = pagination.dataset.nextUrl || '';
        document.dispatchEvent(new CustomEvent('klever:products-added'));
        this.updateStatus();
        this.button.hidden = !this.dataset.nextUrl;
      } catch (_) {
        if (this.isConnected) this.status.textContent = 'No se pudieron cargar más productos. Pulsa Mostrar más para reintentar.';
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = 'Mostrar más ＋';
        this.list.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('klever-load-more', KleverLoadMore);
})();
